import * as actionTypes from "./actionTypes";

export const updateCategoryReducer = (data) => {
  return {
    type: actionTypes.UPDATE_CATEGORY_REDUCER,
    payload: { data },
  };
};
